import { TFunction } from 'i18next';

export enum WfPartArrangementStatus {
  NotArranged = '未手配',
  Arranged = '手配済み',
}

export const WfPartArrangementStatusMapping = (t: TFunction) => ({
  [WfPartArrangementStatus.NotArranged]: {
    title: t('wf.statusInformationRegistration.arrangementOptions.notArranged'),
    value: WfPartArrangementStatus.NotArranged,
  },
  [WfPartArrangementStatus.Arranged]: {
    title: t('wf.statusInformationRegistration.arrangementOptions.arranged'),
    value: WfPartArrangementStatus.Arranged,
  },
});

export const getPartArrangementStatusOptions = (t: TFunction) =>
  Object.values(WfPartArrangementStatusMapping(t));

export const isWfPartArrangementStatus = (
  value: string | undefined
): value is WfPartArrangementStatus =>
  value === WfPartArrangementStatus.Arranged || value === WfPartArrangementStatus.NotArranged;
